export const HUMAN_REVIEW_STATUS = {
  PENDING: "pending",
  COMPLETE: "complete",
} as const;

export const HUMAN_REVIEW_OUTCOME = {
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;
